/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { Button, DropDown } from "../../components";
import DatePicker from "react-multi-date-picker";
import InputIcon from "react-multi-date-picker/components/input_icon";
import { useAppDispatch, useAppSelector } from "../../redux/Hooks/Hook";
import { AllFacilitiesList } from "../../redux/Slice/Facilities/FacilitiesListSlice";
import { AllSportsList } from "../../redux/Slice/Sports/SportsListSlice";
import { TIME_OPTIONS } from "../../utilities/utils";
import { GetFacilityAvailabilityCheckList } from "../../utilities/api/dashboard";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { useReactToPrint } from "react-to-print";

const FacilityAvailabilityCheck = () => {
    const dispatch = useAppDispatch()
    const ComponentRef = useRef<HTMLDivElement>(null)
    const { AllFacilitiesData  , errorMessage} = useAppSelector(state => state.facilityList)
    const { AllSportsData , sportErrorMessage} = useAppSelector(state => state.sportList)
    const [facilityId, setFacilityId] = useState("")
    const [sportId, setSportId] = useState("")
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [startTime, setStartTime] = useState("")
    const [endTime, setEndTime] = useState("")
    const [endTimeOptions, setEndTimeOptions] = useState<any>([])
    const [data, setData] = useState<any>([])
    const [dataCopy, setDataCopy] = useState<any>([])
    const [selectCourt, setSelectCourt] = useState("")
    const [buttonDisable, setButtonDisable] = useState(false)
    const [updatedTime, setUpdatedTime] = useState("")

    useEffect(() => {
        dispatch(AllFacilitiesList("true"))
    }, [])
    if (errorMessage || sportErrorMessage) {
        toast.error(errorMessage.message)
      }

    useEffect(() => {
        facilityId !== "" && dispatch(AllSportsList({ facilityId: facilityId, isActive: "true" }))
    }, [facilityId])

    useEffect(() => {
        let _endTimeArr = TIME_OPTIONS.filter((item: any) => item > startTime)
        setEndTimeOptions(_endTimeArr)
    }, [startTime])

    useEffect(() => {
        if (selectCourt === "") {
            setData(dataCopy)
        } else {
            let _filterData = dataCopy.filter((item: any) => item.courtId == selectCourt)
            setData(_filterData)
        }
    }, [selectCourt])

    const handleSubmit = async () => {
        setButtonDisable(true)
        let _available = await GetFacilityAvailabilityCheckList(facilityId, sportId, format(new Date(startDate), "yyyy-MM-dd"), format(new Date(endDate), "yyyy-MM-dd"), startTime, endTime)
        if (_available.statusCode === 200) {
            setUpdatedTime(`${new Date().toDateString()} | ${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`)
            setData(_available?.data?.availableCourtSlots)
            setDataCopy(_available?.data?.availableCourtSlots)
        } else {
            toast.error(_available.response.data.message)
        }
        setButtonDisable(false)
    }

    const handlePrint = useReactToPrint({
        content: () => ComponentRef.current,
        copyStyles: true,
        pageStyle: `
            @page { size: auto; margin: 10mm; }
            .print-hide { display: none !important; }
            .rmdp-container { display: none !important; }
        `,
    });

    return (
        <>
            <Container fluid className="g-0">
                <Card>
                    <Card.Body>
                        <div ref={ComponentRef} className="print-content">
                            <div className="page-title align-items-center d-flex justify-content-between">
                                <Card.Title className="mb-0">Facility Availability Check</Card.Title>
                            </div>
                            <hr />

                            <Row className="print-hide">
                                <Col lg={6}>
                                    <div className="mb-3 text-start">
                                        <label htmlFor="facility" className="form-label">
                                            Select Facility <small className="text-danger">*</small>
                                        </label>
                                        <DropDown
                                            onChange={(e: any) => {
                                                setFacilityId(e.target.value)
                                                setSportId("")
                                            }}
                                            value={facilityId}
                                            className="form-control"
                                            id="facility"
                                            name="facility">
                                            <option value="">Select Facility</option>
                                            {AllFacilitiesData?.map((item: any) => {
                                                return (
                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                )
                                            })}
                                        </DropDown>
                                    </div>
                                </Col>
                                <Col lg={6}>
                                    <div className="mb-3 text-start">
                                        <label htmlFor="sport" className="form-label">
                                            Select Sport <small className="text-danger">*</small>
                                        </label>
                                        <DropDown
                                            onChange={(e: any) => setSportId(e.target.value)}
                                            value={sportId}
                                            disabled={!facilityId}
                                            className="form-control"
                                            id="sport"
                                            name="sport">
                                            <option value="" >Select Sport</option>
                                            {AllSportsData?.map((item: any) => {
                                                return (
                                                    <option key={item.id} value={item.id}>
                                                        {item.name}
                                                    </option>
                                                );
                                            })}
                                        </DropDown>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div className="mb-3 text-start">
                                        <label htmlFor="from-date" className="form-label">From Date <small>(DD/MM/YYYY)</small> <small className="text-danger">*</small></label>
                                        <DatePicker
                                            id="from-date"
                                            inputClass="form-control"
                                            format="DD/MM/YYYY"
                                            containerClassName="custom-container"
                                            render={<InputIcon className="form-control" />}
                                            minDate={new Date()}
                                            value={new Date(startDate)}
                                            onChange={(date: any) => setStartDate(date?.toDate().toUTCString())}
                                        />
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div className="mb-3 text-start">
                                        <label htmlFor="to-date" className="form-label">To Date <small>(DD/MM/YYYY)</small> <small className="text-danger">*</small></label>
                                        <DatePicker
                                            id="to-date"
                                            inputClass="form-control"
                                            format="DD/MM/YYYY"
                                            containerClassName="custom-container"
                                            render={<InputIcon className="form-control" />}
                                            minDate={new Date(startDate)}
                                            value={new Date(endDate)}
                                            onChange={(date: any) => setEndDate(date?.toDate().toUTCString())}
                                        />
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div className="text-start">
                                        <label htmlFor="starttime" className="form-label">
                                            Start Time
                                        </label>
                                        <DropDown
                                            className="form-control"
                                            id="startTime"
                                            name="startTime"
                                            value={startTime}
                                            onChange={(e: any) => setStartTime(e.target.value)}
                                        >
                                            <option value="">Select</option>
                                            {TIME_OPTIONS.map((item: any) => {
                                                return (
                                                    <option value={item} key={"startTime" + item}>{item}</option>
                                                )
                                            })}
                                        </DropDown>
                                    </div>
                                </Col>
                                <Col lg={3}>
                                    <div className="text-start">
                                        <label htmlFor="endtime" className="form-label">
                                            End Time
                                        </label>
                                        <DropDown
                                            className="form-control"
                                            id="endtime"
                                            name="endtime"
                                            disabled={!startTime}
                                            value={endTime}
                                            onChange={(e: any) => setEndTime(e.target.value)}
                                        >
                                            <option value="">Select</option>
                                            {endTimeOptions?.map((elem: any) => {
                                                return (
                                                    <option value={elem} key={"endTime" + elem}>{elem}</option>
                                                )
                                            })}
                                        </DropDown>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="row-mb print-hide">
                                <Col lg={12} className="text-end mt-3">
                                    <Button disabled={!facilityId || !sportId || !startDate || !endDate || buttonDisable} onClick={handleSubmit} type="submit" bname={buttonDisable ? "Checking Availability" : "Check Availability"} name="check-availability" id="check-availability" className="btn btn-primary px-4 rounded-1"></Button>
                                </Col>
                                <Col lg={12} className="text-end mt-3">
                                    <div className="fs-7 fst-italic fw-semibold">Last Update : {updatedTime}</div>
                                </Col>
                            </Row>
                            <Row className="align-items-center mb-3">
                                <Col lg={6} className="text-start">
                                    <div className="fs-6 fw-semibold">
                                        Available Courts
                                    </div>
                                </Col>
                                {dataCopy.length > 0 && <Col lg={6} className="print-hide">
                                    <Row className="align-items-baseline g-0">
                                        <Col lg={6} className="text-end">
                                            <label htmlFor="courts" className="form-label fs-7 fw-semibold me-2">
                                                Courts
                                            </label>
                                        </Col>
                                        <Col lg={6}>
                                            <DropDown
                                                value={selectCourt}
                                                onChange={(e: any) => setSelectCourt(e.target.value)}
                                                className="form-control"
                                                id="courts"
                                                name="courts">
                                                <option value="" >Select Courts (All)</option>
                                                {dataCopy?.map((_court: any) => {
                                                    return (
                                                        <option value={_court.courtId} key={_court.courtId}>{_court.courtName}</option>
                                                    )
                                                })}
                                            </DropDown>
                                        </Col>
                                    </Row>
                                </Col>}
                            </Row>
                            <Row className="row-mb">
                                {data.length > 0 ?
                                    data.map((item: any, index: number) => {
                                        return (
                                            <Col lg={12} key={index + " " + item.courtId}>
                                                <Card>
                                                    <Card.Body className="p-3">
                                                        <Card.Title className="card-title h5 text-start mb-3">{item.courtName}</Card.Title>
                                                        {item?.courtDatewiseSlots?.map((elem: any, ind: number) => {
                                                            return (
                                                                <Row key={ind + " " + elem.date} className="align-items-center g-0 text-start row-mb">
                                                                    <Col lg={2}>
                                                                        <div className="date-title">
                                                                            {elem.date?.split("-").reverse().join("/")}
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={10} className="gx-4">
                                                                        <div className="courts-time d-flex flex-wrap gap-2">
                                                                            {elem?.availableSlots?.map((_slot: any) => {
                                                                                return (
                                                                                    <div key={_slot.fromTime} className="bg-light d-inline-block p-2 rounded-1 slot-box text-start" style={{ maxWidth: 130 }}>
                                                                                        <span className="d-block text-nowrap">{_slot.fromTime} To {_slot.toTime}</span>
                                                                                    </div>
                                                                                )
                                                                            })}
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            )
                                                        })}
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        )
                                    })
                                    :
                                    <span className="text-danger">
                                        No Slots Available
                                    </span>
                                }
                            </Row>
                        </div>
                        <Row >
                            <Col lg={12} className="text-end">
                                <Button disabled={data.length <= 0} onClick={handlePrint} type="submit" bname="Print Summary" name="printsummary" id="printsummary" className="btn btn-primary px-4 rounded-1"></Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Container>


        </>
    )
}
export { FacilityAvailabilityCheck }
